var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAeroplane2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 148,
    viewBox: "0 0 148 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2154_831)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.272 125.153C68.6616 125.133 65.7712 122.209 65.822 118.63L65.9563 94.8254L31.4732 72.9982L31.4914 64.3391L66.0353 75.3962L66.1699 51.5306L57.5474 45.0258L57.6147 38.5088L72.7051 42.9388L87.9057 38.6796L87.93 45.2277L79.1119 51.6954L78.9783 75.3774L113.736 64.803L113.657 73.4617L78.9294 94.8986L78.7951 118.703C78.8366 122.191 75.7597 125.234 72.272 125.153Z",
    fill: "#E0E0E0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2154_831"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 147.43,
    y: 74.6313,
    width: 103.851,
    height: 103.851,
    rx: 51.9255,
    transform: "rotate(135.323 147.43 74.6313)",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAeroplane2);
export default __webpack_public_path__ + "static/media/aeroplane2.570b56e61037388324996e64807c3e1e.svg";
export { ForwardRef as ReactComponent };